
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';

const NavB = () =>
  {
  return(
    <Navbar fixed="top" bg="light">
      <Navbar.Brand href="#home">Fasting Timer</Navbar.Brand>
    </Navbar>
  )};

export default NavB